import React, { PropsWithChildren } from "react";
import { Box, Container } from "@mui/material";
import SiteHeader from "./SiteHeader";
import { Seo } from "./Seo";

export interface PageProps {
  siteHeader?: boolean;
  title?: string;
  description?: string;
  ogImage?: string;
  backTo?: string;
}

export function Page(props: PropsWithChildren<PageProps>) {
  const {
    children,
    title,
    description,
    ogImage,
    backTo,
    siteHeader = true
  } = props;

  if (!children) {
    return null;
  }

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Seo title={title} description={description} image={ogImage} />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {siteHeader ? <SiteHeader title={title ?? ""} backTo={backTo} /> : null}
        <Box
          component="main"
          id="main-content"
          tabIndex={-1}
          sx={(theme) => ({
            flex: 1,
            padding: "32px 16px",
            [theme.breakpoints.down(360)]: { padding: "32px 8px" },
            [theme.breakpoints.up("sm")]: { padding: "48px 24px" }
          })}
        >
          <Container disableGutters>{children}</Container>
        </Box>
      </Box>
    </>
  );
}
